import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { MdsConfig } from '@maersk-global/mds-config';
import { UtilsService } from './app/shared/services/utils.service';


MdsConfig.iconsDynamicImportPath = '/';

// Initialize RUM telemetry after onboarding this new app
// import { RumInit } from '@maersk-global/telemetry-web-sdk';
// import { environment } from '@src/environments/environment';
// var faro = RumInit({
//   app: {
//     name: environment.config.RUM_APP_NAME,
//     version: '1.0.0',
//     environment: environment.type,
//   },
//   apiKey: environment.config.RUM_API_KEY,
//   debug: !environment.production,
//   traceLog: true,
//   useSendBeacon: true,
// });

function waitForToken(): Promise<void> {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      const token = UtilsService.getUserToken();
      if (token) {
        clearInterval(interval);
        resolve();
      }
    }, 100);

    setTimeout(() => {
      clearInterval(interval);
      resolve();
    }, 2000);
  });
}

waitForToken().then(() => {
  bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
});